var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminForm',{attrs:{"label-width":_vm.controllerFormLableWidth,"columns":_vm.columns,"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('span')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }